import React, { useContext, useEffect, useState, useCallback } from "react";
import { API } from "aws-amplify";
import classNames from "lib/classNames";
import styles from "styles/charge_approval.module.scss";
import Modal from "./Modal";
import ShopContext from "context/ShopContext";
import {
  Icon,
  Range
} from 'components';
import { Redirect } from "@shopify/app-bridge/actions";
import {
  faCheckSquare
} from '@fortawesome/fontawesome-pro-solid';

import EmbeddedContext from "context/EmbeddedContext";
import getPlans, { getBasePrice } from "lib/getPlans";
import { trackMixPanelEvent } from "lib/mixpanel"


const ChargeApproval = ({ }) => {
  const { AppBridgeRedirect } = useContext(EmbeddedContext);
  const shopContext = useContext(ShopContext);
  const {
    state: { chargeConfirmationUrl, redirectToChargeApproval },
    state
  } = shopContext;
  const plans = getPlans(new Date(state.installedAt).getTime());
  const [isModalVisible, setIsModalVisible] = useState(
    redirectToChargeApproval
  );
  const [orderSize, setOrderSize] = useState(10)
  const [isExpanded, setIsExpanded] = useState(false);
  // type: "trial"
  // value: 10
  const [couponOpened, setCouponOpened] = useState(false);
  const [couponCode, setCouponCode] = useState();
  const [discountLoading, setDiscountLoading] = useState(false);
  const [discount, setDiscount] = useState();
  const [discountMessage, setDiscountMessage] = useState();
  const [discountedChargeUrl, setDiscountedChargeUrl] = useState();

  useEffect(() => {
    if (redirectToChargeApproval) {
      AppBridgeRedirect.dispatch(Redirect.Action.REMOTE, chargeConfirmationUrl);
    }
    if (state?.invitation?.type === "discount_percentage") {
      setDiscount(state?.invitation?.value)
      setDiscountMessage({ type: "info", text: "Discount applied: " + state?.invitation?.value + "%" })
    }
  }, [])

  const calculatePrice = (orderSize) => {
    return plans.find(({ transactions }) => orderSize <= transactions)?.real_price
  }
  const handleDiscountApply = async () => {
    if (!couponCode) return
    setDiscountLoading(true)
    // make the call to check the discount
    const result = await API.post("API_GATEWAY_NEW", "/aff/coupon", {
      body: {
        coupon: couponCode
      }
    });
    setDiscountLoading(false)
    if (result.found) {
      setDiscount(result.discount + "%")
      setDiscountMessage({ type: "info", text: "Discount applied: " + result.discount + "%" })
      setDiscountedChargeUrl(result.chargeConfirmationUrl)
      setCouponOpened(false)
    } else {
      setDiscount()
      setDiscountMessage({ type: "error", text: "Discount code not found" })
    }
  }
  const redirect = () => {
    trackMixPanelEvent("Accept charges click", state?.id)
    AppBridgeRedirect.dispatch(Redirect.Action.REMOTE, discountedChargeUrl || chargeConfirmationUrl);
  };
  const footer = (
    <div className={`${classNames("flex items-center justify-between")} `}>
      <div className={classNames("flex items-center	flex-row")}>
        {!discount && <div >
          <div
            className={classNames("font-bold flex items-center cursor-pointer text-gray-500", { ["justify-center"]: !couponOpened })}
            onClick={() => setCouponOpened(!couponOpened)}
            tabIndex="0"
          >
            <svg
              aria-hidden="true"
              focusable="false"
              className={classNames(
                "transition-transform duration-200 ease-out transform",
                {
                  "rotate-45": couponOpened
                }
              )}
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              style={{ width: 13, height: 13 }}
            >
              <path
                fill="currentColor"
                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
              ></path>
            </svg>

            <div className={classNames("leading-full pl-1 text-sm")} >
              Coupon code
            </div>
          </div>
          {couponOpened && (
            <>
              <div className={classNames("mt-2 flex items-stretch")}>
                <div
                  className={`${classNames(
                    "flex rounded border p-1 flex items-center flex-1 border-gray-500"
                  )}`}// ${styles.border_blue_color}
                >
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    className={`${classNames("pr-2 flex-shrink-0")} ${styles.blue_color}`}
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    style={{ width: 25, height: 25 }}
                  >
                    <path
                      fill="currentColor"
                      d="M512 256c0-37.7-23.7-69.9-57.1-82.4 14.7-32.4 8.8-71.9-17.9-98.6-26.7-26.7-66.2-32.6-98.6-17.9C325.9 23.7 293.7 0 256 0s-69.9 23.7-82.4 57.1c-32.4-14.7-72-8.8-98.6 17.9-26.7 26.7-32.6 66.2-17.9 98.6C23.7 186.1 0 218.3 0 256s23.7 69.9 57.1 82.4c-14.7 32.4-8.8 72 17.9 98.6 26.6 26.6 66.1 32.7 98.6 17.9 12.5 33.3 44.7 57.1 82.4 57.1s69.9-23.7 82.4-57.1c32.6 14.8 72 8.7 98.6-17.9 26.7-26.7 32.6-66.2 17.9-98.6 33.4-12.5 57.1-44.7 57.1-82.4zm-320-96c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32zm12.28 181.65c-6.25 6.25-16.38 6.25-22.63 0l-11.31-11.31c-6.25-6.25-6.25-16.38 0-22.63l137.37-137.37c6.25-6.25 16.38-6.25 22.63 0l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63L204.28 341.65zM320 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                    ></path>
                  </svg>
                  {!!discount && (
                    <div
                      className={`${classNames("flex px-2 py-1 rounded relative text-white")} ${styles.bg_blue_color}`}
                    >
                      <span className={classNames("flex-1")}>{couponCode}</span>
                    </div>
                  )}
                  {!discount && (
                    <input
                      value={couponCode}
                      placeholder={"enter coupon code"}
                      onChange={({ target }) => {
                        if (!discount) setCouponCode(target.value);
                      }}
                      disabled={!!discount}
                      className={classNames(
                        "border-0 shadow-none focus:outline-none bg-transparent w-full text-sm"
                      )}
                    />
                  )}
                </div>
                <button
                  onClick={() => handleDiscountApply()}
                  disabled={!!discount || discountLoading}
                  style={{ flex: 0 }}
                  className={`${classNames("ml-2 px-3 btn-small flex-0 text-white")} ${styles.bg_blue_color}`}
                >
                  Apply
                </button>
              </div>
            </>
          )}
        </div>
        }
        {discountMessage && (
          <div
            className={classNames("pt-2 p-1 rounded  font-bold", {
              "text-green-500":
                discountMessage.type === "info",
              "text-red-500":
                discountMessage.type === "error"
            })}
          >
            {discountMessage.text}
          </div>
        )}
      </div>
      <div className={`${classNames("flex")} `}>
        <a
          className={`${classNames(
            "py-2 px-5 font-bold text-sm cursor-pointer flex items-center"
          )} ${styles.blue_color}`}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          Pricing table
          <svg
            className={`${classNames("duration-300", {
              "transform ": isExpanded,
              "rotate-180": isExpanded
            })}`}
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.2625 10.7375L15 16.4625L20.7375 10.7375L22.5 12.5L15 20L7.5 12.5L9.2625 10.7375Z"
              fill="#0053DC"
            />
          </svg>
        </a>
        <a
          className={`${classNames(
            "py-2 px-5 font-bold rounded-sm text-white text-sm cursor-pointer flex items-center"
          )} ${styles.bg_blue_color}`}
          onClick={() => redirect()}
        >
          Get Access
        </a>
      </div>
    </div>
  )


  return (
    <div className={classNames("absolute z-50")}>
      <Modal
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        style={{ minWidth: "900px", minHeight: isExpanded ? "485px" : "205px" }}
        background="bg-white"
        title={<div className={classNames(" font-bold flex-center text-2xl")} >  Welcome to MonsterUpsells <span>👋</span>  </div>}
        footer={footer}
      >
        {(close, setTitle) => (
          <div
            id="monster-upsell-cart"
            className={classNames("px-4 h-full w-full ")}
          >
            <div
              className={`${classNames("w-full text-center")} ${styles.navy_color}`}
            >

              <div className={classNames("py-2")}>
                <p> The next page is a Shopify charge page. </p>
              </div>
              <div className={classNames("py-2")}>
                <p> Although it might seem scarry...</p>
                <p> Dont worry! </p>
              </div>
              <div className={classNames("py-2 font-bold")}>
                <p> YOU WILL NOT BE CHARGED UNLESS YOU KEEP THE APP LONGER THAN <u>THE 10-DAYS FREE TRIAL</u>.</p>
              </div>
              <div className={classNames("py-2")}>
                <p> The app starts at ${getBasePrice(new Date(state.installedAt).getTime())} and increases depending on order volume.  </p>
              </div>
            </div>
            <div
              className={`${classNames("flex ", {
                "pb-6": isExpanded
              })} ${styles.table} ${isExpanded ? "" : styles.hidden_pricing}`}
            >
              <div className={`${classNames("flex-1 p-2 m-2 h-full rounded")} ${styles.bg_lighter_blue_color}`}>
                <div className={classNames("py-3 font-bold flex justify-center")}>
                  <p> <u>Our pricing</u></p>
                </div>
                <div className={classNames("py-2 flex justify-center")}>
                  <p className={classNames("text-center w-2/3")}> How many monthly orders does your store have?</p>
                </div>
                <div className={classNames("px-6 py-4")}>
                  <Range
                    value={orderSize}
                    onChange={setOrderSize}
                    min={1}
                    max={3001}
                  />
                </div>
                <div className={classNames(" py-6 px-6 flex items-center justify-between	")}>
                  <div className={classNames(" mb-2")}> <div className={classNames("p-1 bg-white rounded text-center ")}>{orderSize === 3001 ? "Over 3000+" : `Up to ${orderSize}`} </div> <div className={classNames("")}> Orders per Month</div></div>
                  <div className={classNames(" text-center ")}>  <div>${calculatePrice(orderSize)}</div> <div className={classNames("")}> Price </div></div>
                </div>
              </div>
              <div className={classNames("flex-1  p-2 m-2")}>
                <div className={classNames("py-2 font-bold")}>
                  <p> <u>Why MonsterUpsells?</u></p>
                </div>
                <div className={classNames("flex py-2")}>
                  <Icon color={"#48bb78"} icon={faCheckSquare} size="lg" />
                  <p className={classNames("pl-2")} > Average revenue increase 10-15%</p>
                </div>
                <div className={classNames("flex py-2")}>
                  <Icon color={"#48bb78"} icon={faCheckSquare} size="lg" />
                  <p className={classNames("pl-2")} > 10 Day free trial</p>
                </div>
                <div className={classNames("flex py-2")}>
                  <Icon color={"#48bb78"} icon={faCheckSquare} size="lg" />
                  <p className={classNames("pl-2")} > Beautiful user experience</p>
                </div>
                <div className={classNames("flex py-2")}>
                  <Icon color={"#48bb78"} icon={faCheckSquare} size="lg" />
                  <p className={classNames("pl-2")} > Powerful upsells offers</p>
                </div>
                <div className={classNames("flex py-2")}>
                  <Icon color={"#48bb78"} icon={faCheckSquare} size="lg" />
                  <p className={classNames("pl-2")} > Average ROI of 2000%+</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ChargeApproval;
